import api from './api';
import './data/notifications/notifications-db';
import './data/apps.chat';

api.onAny().passThrough();
